import React, { useState } from "react";
import Nestora from "../images/Nestora.png";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otpCode, setOtpCode] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    setOtpCode(true);
  };
  const handleBackClick = () => {
    navigate("/register");
  };
  return otpCode ? (
    <div className="flex flex-col items-center justify-center h-[100vh] bg-slate-50 ">
        
      <div className="flex items-center flex-col   bg-white p-4 relative">
      <ArrowLeft
            className="absolute left-0 top-2 text-xl  cursor-pointer hover:bg-slate-100/60 w-10 h-10 p-2  rounded-full"
            onClick={handleBackClick}
          />
        <h1 className="text-blue-700 font-semibold ml-3">
          Have You Received a verification code?
        </h1>
        <p className="text-sm text-gray-500 ml-3">
          We sent an 6-digits code to your {email}...
        </p>
        <form >
          <div className="flex gap-2 mt-4 flex-wrap">
            <input
              placeholder="0"
              className="placeholder:text-gray-500 bg-slate-200/70 p-2 w-[30px] h-[35px] text-center rounded-md"
            ></input>
            <input
              placeholder="0"
              className="placeholder:text-gray-500 bg-slate-200/70 p-2 w-[30px] h-[35px] text-center rounded-md"
            ></input>
            <input
              placeholder="0"
              className="placeholder:text-gray-500 bg-slate-200/70 p-2 w-[30px] h-[35px] text-center rounded-md"
            ></input>
            <input
              placeholder="0"
              className="placeholder:text-gray-500 bg-slate-200/70 p-2 w-[30px] h-[35px] text-center rounded-md"
            ></input>
            <input
              placeholder="0"
              className="placeholder:text-gray-500 bg-slate-200/70 p-2 w-[30px] h-[35px] text-center rounded-md"
            ></input>
            <input
              placeholder="0"
              className="placeholder:text-gray-500 bg-slate-200/70 p-2 w-[30px] h-[35px] text-center rounded-md"
            ></input>
          </div>
          <button type="submit" className="text-center bg-blue-500 text-white pt-2 pb-2 pl-4 pr-4 w-[100%] mt-3 rounded-lg hover:bg-blue-700 transition-colors-[400ms] ">
            Verify
          </button>
        </form>
      </div>
    </div>
  ) : (
    <div className="flex  justify-center items-center h-[100vh] bg-slate-50">
      <div className="p-4 bg-white flex flex-col items-center">
        <div className="flex items-center justify-center relative w-[100%]">
          <ArrowLeft
            className="absolute left-0 text-xl  cursor-pointer hover:bg-slate-100/60 w-10 h-10 p-2  rounded-full"
            onClick={handleBackClick}
          />
          <img src={Nestora} alt="Nestora" className="w-[80px] h-[80px]"></img>
          <p className="text-md font-medium">Nestora</p>
        </div>
        <div>
          <form
            className="w-[300px] p-6 rounded-lg bg-white drop-shadow-sm flex flex-col "
            onSubmit={handleSubmit}
          >
            <h1 className="text-xl text-blue-700  font-semibold">
              Forgot Password
            </h1>
            <p className="text-sm text-gray-500  ">
              Enter Your Mail to get code
            </p>
            <input
              required
              type="email"
              placeholder="Enter Your Mail"
              className="border-2 w-[100%] h-5 pl-2 pt-4 pb-4 placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none mt-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            ></input>
            <button className="bg-blue-500 hover:bg-blue-700 transition-colors duration-400Z w-full  pt-2 pb-2 rounded-lg text-white mt-3">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
